import { useState, type FC, type ImgHTMLAttributes } from 'react';
import Text from '@/components/base/Text';
import { toClassNames } from '@/utils';

type ImgElementProps = ImgHTMLAttributes<HTMLImageElement>;

export type AvatarProps = {
  name: string;
  className?: string;
  textClassName?: string;
  imgClassName?: string;
} & ImgElementProps;

const Avatar: FC<AvatarProps> = ({ name, className, textClassName, imgClassName, ...imgProps }) => {
  const [imgLoadError, setImgLoadError] = useState(false);

  const hasImg = Boolean(imgProps.src || imgProps.srcSet);

  return (
    <div
      data-test-id="avatar-div"
      className={toClassNames(
        'aspect-square h-8 w-8',
        'flex items-center justify-center',
        'overflow-hidden rounded-full',
        'bg-[#52BC89] text-white', // TODO: unnamed color
        'border border-white',
        className
      )}
    >
      {hasImg && !imgLoadError ? (
        <img
          data-test-id="avatar-img"
          className={toClassNames('h-full w-full', imgClassName)}
          src={imgProps.src}
          alt={imgProps.alt || name}
          srcSet={imgProps.srcSet}
          sizes={imgProps.sizes}
          loading={imgProps.loading}
          referrerPolicy={imgProps.referrerPolicy}
          crossOrigin={imgProps.crossOrigin}
          onError={() => setImgLoadError(true)}
        />
      ) : (
        <Text
          dataTestId="avatar-text"
          variant="xl"
          className={toClassNames('font-semibold capitalize text-inherit', textClassName)}
        >
          {name[0]}
        </Text>
      )}
    </div>
  );
};

export default Avatar;
